import { HOUR, MINUTE, type SourceDefinition } from '../types';

export const config = {
  id: 'location',
  kind: 'gcs',
  url: 'https://storage.googleapis.com/life-sync-bucket/location.json',
  refetchMiliseconds: 5 * MINUTE,
  staleAfterMiliseconds: 24 * HOUR,
  preload: 'fetch',
} satisfies SourceDefinition;
